"use strict";
/*
 * THIS MATERIAL IS THE CONFIDENTIAL, PROPRIETARY AND TRADE SECRET PRODUCT OF
 * BLUECROSS BLUESHIELD OF SOUTH CAROLINA AND ITS SUBSIDIARIES. ANY
 * UNAUTHORIZED USE, REPRODUCTION OR TRANSFER OF THESE MATERIALS IS STRICTLY
 * PROHIBITED.
 *
 * COPYRIGHT 2022 BLUECROSS BLUESHIELD OF SOUTH CAROLINA ALL RIGHTS RESERVED.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isObject = exports.isNotEmpty = exports.isEmpty = void 0;
/**
 * @description: Utility for object utilities
 */
/**
 * Checks if the supplied value is empty or not
 *
 * @param value, the value to check for
 * @returns true if isEmpty
 */
function isEmpty(value) {
    if (isObject(value) && Object.keys(value).length === 0) {
        return true;
    }
    else {
        return false;
    }
}
exports.isEmpty = isEmpty;
/**
 * Checks if the supplied value is not empty
 *
 * @param value, the value to check for
 * @returns boolean
 */
function isNotEmpty(value) {
    return !isEmpty(value);
}
exports.isNotEmpty = isNotEmpty;
/**
 * Checks if the supplied value is an object
 *
 * @param value, the value to check for
 * @returns true, if the value is an object
 */
function isObject(value) {
    return value !== null && typeof value === 'object' && Object(value) === value;
}
exports.isObject = isObject;
//# sourceMappingURL=index.js.map